export default [{
        path: '/discountcoupons',
        name: 'discountcoupons',
        component: () =>
            import ('@/views/modules/discountcoupons/discountcoupons-list/DiscountCouponsList.vue'),
        meta: {
            resource: 'ACL',
            pageTitle: 'Cupones',
            breadcrumb: [{
                text: 'Lista de cupones',
                active: true
            }]
        }
    },
    {
        path: '/discountcoupon/create',
        name: 'discountcoupon-create',
        component: () =>
            import ('@/views/modules/discountcoupons/discountcoupons-store/DiscountCouponStore.vue'),
        meta: {
            pageTitle: 'Cupones',
            breadcrumb: [{
                text: 'Lista de cupones',
                to: { name: 'discountcoupons' }
            }, {
                text: 'Nuevo cupón',
                active: true
            }]
        }
    },
    {
        path: '/discountcoupon/:id/edit',
        name: 'discountcoupon-edit',
        component: () =>
            import ('@/views/modules/discountcoupons/discountcoupons-edit/DiscountCouponsEdit.vue'),
        meta: {
            pageTitle: 'Cupones',
            breadcrumb: [{
                text: 'Lista de cupones',
                to: { name: 'discountcoupons' }
            }, {
                text: 'Editar cupón',
                active: true
            }]
        }
    }
]